import React, { useState, useEffect } from "react";
import "./Homepage.scss";
import { Button, Card, Col, Container, ListGroup, Row } from "react-bootstrap";
import MainLayout from "../layouts/MainLayout";
import { getMyActivity } from "../api/actions/Me";

import DocumentOutline from "react-ionicons/lib/DocumentOutline";
import ChatbubblesOutline from "react-ionicons/lib/ChatbubblesOutline";
import CheckmarkCircle from "react-ionicons/lib/CheckmarkCircle";
import EllipseOutline from "react-ionicons/lib/EllipseOutline";
import languageManager from "../helpers/Language";
import DriveActivityList from "../components/DriveActivity/ActivityListGroup";

import FolderOneURL from "../assets/img/draw-kit/chart_graph_1.svg";
import ServerPicOneURL from "../assets/img/draw-kit/server_pic_1.svg";
import { connect } from "react-redux";
import { getMyOTPStatus } from "../api/actions/Session";
import SkeletonBox from "../components/SkeletonBox/SkeletonBox";

export const DFLT_ICO_PROPS = {
  height: "24px",
  width: "24px",
  color: "inherit",
};

export const TODO_ICO_PROPS = {
  height: "32px",
  width: "32px",
  color: "inherit",
};

const AccountSetupItem = ({ title, isComplete, shimmer }) => {
  let completedStatusIcon = (
    <SkeletonBox className="rounded" style={{ minWidth: 30, height: 32 }} />
  );
  if (!shimmer) {
    completedStatusIcon = isComplete ? (
      <CheckmarkCircle {...TODO_ICO_PROPS} />
    ) : (
      <EllipseOutline {...TODO_ICO_PROPS} />
    );
  }
  return (
    <ListGroup.Item>
      <Row className="account-setup-item">
        <Col
          style={{ maxWidth: "40px" }}
          className={[
            "task-status d-flex align-items-center justify-content-center",
            isComplete ? "completed" : "pending",
          ]}
        >
          {completedStatusIcon}
        </Col>
        <Col style={{ paddingTop: "4px" }} className="ps-1">
          <span className="h5">{title || "-"}</span>
        </Col>
      </Row>
    </ListGroup.Item>
  );
};

const Homepage = ({ userProfile }) => {
  const [hasOTPEnabled, setOTPStatus] = useState(null);
  const [myDriveActivity, setMyDriveActivity] = useState(null);
  const u = userProfile || {};
  const fullUserName = `${u.firstname} ${u.lastname}`;
  const handleRefreshMyActivity = async () => {
    setMyDriveActivity(null);
    const res = await getMyActivity();
    const d = Array.isArray(res.data) ? res.data : [];
    const driveActivity = d.filter((af) => af.activityFeed.origin === "drive");
    setMyDriveActivity(driveActivity);
  };
  const handleRefreshOTPStatus = async () => {
    const res = await getMyOTPStatus();
    setOTPStatus(res.data);
  };
  useEffect(() => {
    handleRefreshMyActivity();
    handleRefreshOTPStatus();
  }, []);

  return (
    <MainLayout pageTitle={languageManager.T("HOMEPAGE_TITLE_HOME")}>
      <Container>
        <h1>{languageManager.T("HOMEPAGE_LABEL_WELCOME")}</h1>
        <h2 className="text-muted">{fullUserName}</h2>
        <Row>
          <Col lg={6} style={{ marginTop: "20px", textAlign: "center" }}>
            <img src={ServerPicOneURL} height={350} />
          </Col>
        </Row>
        <Row>
          <Col lg={6} style={{ marginTop: "20px" }}>
            <h4 onClick={handleRefreshMyActivity}>
              {languageManager.T("HOMEPAGE_LABEL_DOCUMENTS")}{" "}
              <span className="text-muted h6">
                - {languageManager.T("HOMEPAGE_LABEL_DOCUMENTS_RECENT_TEXT")}
              </span>
            </h4>
            <DriveActivityList className="shadow-sm" items={myDriveActivity} />
          </Col>
          <Col lg={6} style={{ marginTop: "20px", textAlign: "center" }}>
            <img src={FolderOneURL} height={350} />
          </Col>
        </Row>
      </Container>
    </MainLayout>
  );
};

const mapStateToProps = (appState) => ({
  userProfile: appState.userProfile,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Homepage);
